import { AfterViewInit, Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { AppModalOverlayRef } from 'src/app/shared/services/app-modal.service';

@Component({
  standalone: false,
  selector: 'app-modal-transference-success',
  templateUrl: './modal-transference-success.component.html',
  styleUrls: ['./modal-transference-success.component.scss'],
})
export class ModalTransferenceSuccessComponent implements OnInit, AfterViewInit {
  title = 'Sucesso!';
  description = 'Transferência dos créditos foi realizada com sucesso.';
  operationCode = '';
  consultRoute = '/consulta-operacoes';

  constructor(
    public dialogRef: AppModalOverlayRef<ModalTransferenceSuccessComponent>,
    private router: Router,
    private el: ElementRef,
    private renderer: Renderer2,
  ) {}

  ngOnInit(): void {
    const data = this.dialogRef.data ?? {};
    this.title = data.title ?? this.title;
    this.description = data.description ?? this.description;
    this.operationCode = data.operationCode ?? '';
    this.consultRoute = data.consultRoute ?? this.consultRoute;
  }

  ngAfterViewInit(): void {
    this.renderer.setStyle(this.el.nativeElement, 'display', 'contents');
  }

  close(): void {
    this.dialogRef.close();
  }

  onNewTransference(): void {
    this.dialogRef.close();
  }

  onConsultOperation(): void {
    this.router.navigate([this.consultRoute]);
    this.dialogRef.close();
  }
}
